/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Icon, Image } from 'semantic-ui-react';

import * as AppActions from '../../../actions';
import { getS3Bucket } from '../../../containers/Domains';
import AssetGallery from '../../../components/common/AssetGalleryV2/AssetGallery';
import './AdCarouselCard.css';

const s3BucketUrl = getS3Bucket();

class AdCarouselCard extends Component {
  state = {
    token: this.props.getFbToken(),
    tilePreview: '',
    tile: null
  };

  componentDidMount() {
    if (this.props.card && this.props.edit) {
      this.initializeEdit();
    }
  }

  initializeEdit = () => {
    this.setState({
      tilePreview: this.props.card.tile.tilePreview,
      tile: this.props.card.tile
    });
  };

  removeCard = () => {
    this.props.removeCard(this.props.cardNumber);
  };

  handleCardChange = (event, { name, value }) => {
    this.setState({ name: value });
    this.props.handleCardChange(event, { name, value });
  };

  moveLeft = () => {
    this.props.swapCard(this.props.cardNumber, 'left');
  };

  moveRight = () => {
    this.props.swapCard(this.props.cardNumber, 'right');
  };

  onSelectTile = (asset, cardNumber) => {
    const filename = asset.filename;
    const extension = filename.split('.').slice(-1);
    const tilePreview = `${s3BucketUrl}${asset.guid}.${extension}`;

    this.setState({ tile: asset, tilePreview });
    this.props.handleCardChange(
      { target: { id: cardNumber } },
      { name: 'tile', value: asset }
    );
    this.props.handleCardChange(
      { target: { id: cardNumber } },
      { name: 'tilePreview', value: tilePreview }
    );
  };

  render() {
    const { card, cardNumber, totalCards, tilePreviewProp } = this.props;
    const tilePreview = this.state.TilePreview || tilePreviewProp;

    return (
      <div>
        {card ? (
          <div className="ad-carrousel-card-container">
            <h3>Product {cardNumber}</h3>
            <div className="arrows-container">
              {cardNumber !== 1 ? (
                <a className="arrow-icon" onClick={this.moveLeft}>
                  <Icon size="large" name="arrow alternate circle left" />
                </a>
              ) : null}
              {cardNumber !== totalCards ? (
                <a className="arrow-icon" onClick={this.moveRight}>
                  <Icon size="large" name="arrow alternate circle right" />
                </a>
              ) : null}
            </div>
            {cardNumber !== 1 ? (
              <a className="remove-card" onClick={this.removeCard}>
                <Icon size="large" name="trash" />
              </a>
            ) : null}
            <div className="asset-container">
              {tilePreview ? (
                tilePreview.indexOf('.mp4') !== -1 ? (
                  <video
                    className="ad-carousel-builder-tile-preview"
                    key={tilePreview}
                    controls
                    loop
                    autoPlay
                    muted
                  >
                    <source src={tilePreview} type="video/mp4" />
                    <track default kind="captions" srcLang="en" src="" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <Image
                    src={tilePreview}
                    className="ad-carousel-builder-image-preview"
                  />
                )
              ) : null}
            </div>
            <Form.Input
              className="ad-carrousel-card-input-name"
              placeholder="Headline"
              type="text"
              name="headline"
              id={cardNumber}
              defaultValue={card.headline}
              value={card.headline}
              onChange={this.handleCardChange}
            />
            <Form.Input
              className="ad-carrousel-card-input-name extra-space"
              placeholder="Description"
              type="text"
              name="description"
              id={cardNumber}
              defaultValue={card.description}
              value={card.description}
              onChange={this.handleCardChange}
            />
            <AssetGallery
              getFbToken={this.props.getFbToken}
              onAssetSelected={(asset) => this.onSelectTile(asset, cardNumber)}
              assetType="video"
              previewFileUrl={tilePreview}
              displayPreview={false}
            />
          </div>
        ) : (
          <div className="ad-carrousel-card-container">
            <div className="add-icon">
              <a className="card-icon" onClick={this.props.addCard}>
                <Icon size="huge" name="plus circle" />
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdCarouselCard);



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdCarouselCard.js